import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AtmIcon(props: IconProps) {
    return <Icon {...props} iconKey={"atm"}/>
}
